import { Controller, UseFormReturn } from 'react-hook-form';
import { ValidateUtils } from '@shared/utils';
import { IFormDataIndividualBetween } from '../betweenAccount';
import { IFormDataIndividualOther } from '../otherTransfer';
import { IFormDataIndividualCreate } from '../../../payments/subPages/recipientEditor/subPages/individualRecipient';
import { BaseInput, ErrorMessage, Text } from '@shared/widgets';

export type PersonalFormDataType = IFormDataIndividualBetween | IFormDataIndividualCreate | IFormDataIndividualOther;

interface PropsType {
  formControl: UseFormReturn<PersonalFormDataType, undefined>;
}

export const PersonalFormBlock = (props: PropsType) => {
  return (
    <>
      <Text className='mt-6'>Personal Information</Text>
      <Controller
        name='firstName'
        control={props.formControl.control}
        rules={{
          required: ValidateUtils.requiredErrorMessage,
          maxLength: 100,
          validate: (value) => {
            return ValidateUtils.validateFields(value, 'First Name');
          },
        }}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <BaseInput className='my-2' placeholder='First Name' onChange={onChange} required value={value} />
            <ErrorMessage text={error?.message} />
          </>
        )}
      />
      <Controller
        name='lastName'
        control={props.formControl.control}
        rules={{
          required: ValidateUtils.requiredErrorMessage,
          maxLength: 100,
          validate: (value) => {
            return ValidateUtils.validateFields(value, 'Last Name');
          },
        }}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <BaseInput className='my-2' placeholder='Last Name' onChange={onChange} required value={value} />
            <ErrorMessage text={error?.message} />
          </>
        )}
      />
      <Controller
        name='idNumber'
        control={props.formControl.control}
        rules={{
          required: ValidateUtils.requiredErrorMessage,
          maxLength: 100,
        }}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <BaseInput className='my-2' placeholder='Id Number' onChange={onChange} required value={value} />
            <ErrorMessage text={error?.message} />
          </>
        )}
      />
      <Controller
        name='email'
        control={props.formControl.control}
        rules={{
          required: ValidateUtils.requiredErrorMessage,
          maxLength: 100,
          validate: (value) => {
            const isEmailValid = ValidateUtils.validateEmail(value);
            return isEmailValid ? undefined : 'Enter valid email address';
          },
        }}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <BaseInput type='email' placeholder='Email' required onChange={onChange} value={value} />
            <ErrorMessage text={error?.message} />
          </>
        )}
      />
    </>
  );
};
